import type { ApiISOTimeString } from '#/api/types/ApiTypedDate';
import { I18nLocale } from '#/i18n/types/I18nLocale';

function amPmHours(hours: number) {
  if (hours < 12) {
    return { number: hours === 0 ? 12 : hours, suffix: 'AM' };
  }

  const pmHoursNumber = hours - 12;
  return { number: pmHoursNumber === 0 ? 12 : pmHoursNumber, suffix: 'PM' };
}

/**
 * @example
 *
 * Given 1:32 PM
 *
 * //=> EN (h:mm a)
 * 1:32 PM
 *
 * //=> ES, PT (H:mm)
 * 13:32
 */
export function humanIsoTimeString(
  time: ApiISOTimeString,
  { locale }: { locale: I18nLocale },
) {
  const [twoDigitHours, twoDigitMinutes] = time.split(':');

  const hours = Number(twoDigitHours);
  const amPm = amPmHours(hours);

  switch (locale) {
    case I18nLocale.EN:
      return `${amPm.number}:${twoDigitMinutes} ${amPm.suffix}`;
    case I18nLocale.ES:
    case I18nLocale.PT:
      return `${hours}:${twoDigitMinutes}`;
  }
}
